// extracted by mini-css-extract-plugin
export default {"container":"adminOpstiUslovi_container__u3GUk"};